export const SCRAMBLE_CASES = ['F', 'B', 'R', 'L', 'U', 'D', 'F\'', 'B\'', 'R\'', 'L\'', 'U\'', 'D\'', 'F2', 'B2', 'R2', 'L2', 'U2', 'D2'];

export const bgColors = {
    blue: '#176FD4',
    orange: '#FFBA66',
    green: '#6FE86F',
    red: '#EB6363',
};